export default __webpack_public_path__ + "static/media/anuj.38c2c6b1.png";